// default configurations in all the production/uat/local environments
module.exports = {
    env: "production",
    header: "",
    bulkFxStartTime: "09:00:00",
    bulkFxEndTime: "16:00:00",
    publicHolidays: {
        sg: [
            "2021-11-04",
            "2021-12-25",
            "2022-01-01",
            "2022-02-01",
            "2022-02-02",
            "2022-04-15",
            "2022-05-01",
            "2022-05-02",
            "2022-05-03",
            "2022-05-15",
            "2022-05-16",
            "2022-07-09",
            "2022-08-09",
            "2022-10-24",
            "2022-12-25",
            "2022-12-26",
        ]
    },
    swiftTargetCcyBankCharges: ["USD", "EUR", "JPY", "NZD", "CHF", "GBP"],
};
  